export const formatOrderDate = (placed: string|null|undefined): string => {
    const date = placed ? new Date(placed.split('T')[0]) : new Date();

    const month = date.toLocaleString('nl-NL', { month: 'long' });

    return `${date.getDate()} ${month} ${date.getFullYear()}`;
}